import { render, staticRenderFns } from "./JrzbAdd.vue?vue&type=template&id=7a47f9af&scoped=true"
import script from "./JrzbAdd.vue?vue&type=script&lang=js"
export * from "./JrzbAdd.vue?vue&type=script&lang=js"
import style0 from "./JrzbAdd.vue?vue&type=style&index=0&id=7a47f9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a47f9af",
  null
  
)

export default component.exports